export type CateringTeamOrderContext = {
  ordererName: string
  deliveryDateIso: string | null
  deliveryTime: string | null
  locationLabel: string
}

type OwnedBasket = {
  isCateringTeamOrder?: boolean | null
  userId?: string | number | null
  settings?: { account?: { id?: string | number | null } | null } | null
}
export type BasketViewer = { id: string | number; accountId?: string | number | null }
type BannerBasket = {
  user?: { firstName?: string | null } | null
  settings?: { deliveryDate?: string | null; deliveryTimeSlot?: string | null } | null
}

// A contributor is an authenticated viewer on someone else's group basket within their own
// account; the owner, an anonymous viewer, a standard basket, or another account's basket (the
// same rule useBasketSelection applies as account_mismatch) never count.
export const isBasketContributor = (
  basket: OwnedBasket | null | undefined,
  viewer: BasketViewer | null | undefined,
) => {
  if (!viewer || !basket?.isCateringTeamOrder || basket.userId == null) return false
  if (String(basket.userId) === String(viewer.id)) return false
  const basketAccountId = basket.settings?.account?.id
  return (
    basketAccountId == null ||
    viewer.accountId == null ||
    String(basketAccountId) === String(viewer.accountId)
  )
}

export const buildContributorContext = (
  basket: BannerBasket,
  locationLabel: string | null | undefined,
): CateringTeamOrderContext => ({
  ordererName: basket.user?.firstName ?? '',
  deliveryDateIso: basket.settings?.deliveryDate ?? null,
  deliveryTime: basket.settings?.deliveryTimeSlot ?? null,
  locationLabel: locationLabel ?? '',
})
